import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_VISITORS_QUERY_KEY } from '~/features/hooks/useGetVisitors'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { supabaseApi } from '~/supabase/api'
import { Visitor } from '~/supabase/types'

export type CreateVisitorPayload = Omit<Visitor, 'id' | 'created_at'> & { created_at?: string }
export const useCreateVisitor = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['create-visitor'] as const,
    mutationFn: async (payload: CreateVisitorPayload) => {
      const { error, data } = await supabaseApi.from('visitors').insert(payload).select().single()

      if (error) {
        console.error(error)
        toast.error('There has been an error. Check your console')
        notifyError({
          message: 'Something went wrong while creating visitor.',
          function: 'createVisitor',
          error,
          data: { formData: data },
        })
        throw error
      }

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_VISITORS_QUERY_KEY] })
      toast.success('Visitor created!')
    },
  })
}
